module.exports = __webpack_public_path__ + "img/lightening-grey.46278752.svg";